export const ScheduleTypeColor = {
  1: '#8acdc3',
  2: '#ff9100',
  3: '#d28ac5',
  4: '#6fc908',
  5: '#966bc7'
};
